import React from 'react';
import styled from 'styled-components';
import { split } from 'lodash';

const EsOrderDoneProdInfoBlock = styled.div``;

const EsOrderDoneProdInfo = ({ esOrderInfo, isShowGuide = true }) => {

    const getDlvryPayInFooter = (item) => {

        // 착불
        if (item.od_dlvry_type === '025202' || item.od_dlvry_price > 0) {
            return (<span className="esd_pay">
                {Number(item.od_dlvry_price.toFixed(1)).toLocaleString()}원
            </span>)
        } else {
            return (<p className="pt-pay normal">무료 배송</p>)
        }
    }


    const isCashOnDlvryShow = (item) => {
        if (item.od_dlvy_pay_type === '025202') {
            return { display: 'block' };
        } else {
            return { display: 'none' };
        }
    }

    const getDetailDlvry = (item) => {
        if (item.od_dlvy_pay_type > 0) {
            if (item.od_dlvry_fee > 0) {
                return (<p className="fontsize-14">
                    {Number(item.od_dlvry_fee.toFixed(1)).toLocaleString()}원</p>)
            } else {
                return (<div>
                    <p className="fontsize-14">무료</p>
                </div>)
            }
            /* 
            return (<p className="fontsize-14">
                {Number(item.od_dlvry_fee.toFixed(1)).toLocaleString()}원</p>) */
        } else {
            return (<div>
                <p className="fontsize-14">무료</p>
            </div>)
        }

        

    }

    const getCateName = (cate_name) => {

        if (cate_name !== null) {
            let catenames = split(cate_name, '>');
            return catenames[1];
        }

        return "";
    }


    const getDscntPercent = (item) => {

        if (item.od_dscnt_per > 0) {
            return (<p><span className="dotted-tag red"><span>{item.od_dscnt_per}</span>%</span></p>);
        } else {
            return ("");
        }
    }

    const getDscntPriceNoDot = (item) => {
        if (item.od_dscnt_per > 0 || item.od_dscnt_price > 0) {
            return (<p className={item.od_add_dscnt_price > 0 ? "sale_plus pink fontsize-14" : "pink fontsize-14"}>
                <span className="font-mont">
                    -{Number(item.od_dscnt_price.toFixed(1)).toLocaleString()}</span>원</p>)
        } else {
            return ("");
        }
    }

    const getAddDscntPrice = (item) => {

        if (item.od_add_dscnt_price > 0) {
            return (<p className="pink fontsize-14">
                <span>추가할인</span><br />
                <span className="font-mont">-
                {Number(item.od_add_dscnt_price.toFixed(1)).toLocaleString()}</span>원
            </p>);
        } else {
            return ("");
        }
    }

    // 총 할인 금액 반환
    const getTotalDsctPrice = (item) => {
        return (Number(item.od_es_sale_price.toFixed(1)).toLocaleString());
    }

    const getId = () => {
        if(esOrderInfo.data.orderinfo.es_rqst_id !== undefined && esOrderInfo.data.orderinfo.es_rqst_id !== null)
        {
            return esOrderInfo.data.orderinfo.es_rqst_id;
        }

        return esOrderInfo.data.orderinfo.es_id;
    }
    return (
        <EsOrderDoneProdInfoBlock>
            <div>
                <div className="filter-top myes_top clearfix">
                    <span className="f-left"><b style={{ fontSize: '18px' }}>주문 상품 정보</b></span>
                    <div className="filter-fc f-right clearfix">
                        <p>
                            {/* #2824 es_id->es_rqst_id 로 변경 */}
                            {esOrderInfo.data.orderinfo.brnd_han} <span className="d-inline margin_l-20 font-mont">NO. {getId()}</span>
                        </p>
                    </div>
                </div>

                <div className="product-table default-table margin_b-20">
                    <table>
                        <colgroup>
                            <col width="550px;" />
                            <col width="156px;" />
                            <col width="156px;" />
                            <col width="156px;" />
                            <col width="156px;" />
                        </colgroup>

                        <thead>
                            <tr>
                                <th>상품 정보</th>
                                <th>상품 금액</th>
                                <th>할인 금액</th>
                                <th>배송비</th>
                                <th>견적 금액</th>
                            </tr>
                        </thead>

                        <tbody>
                            {
                                esOrderInfo.data.items.map((curitem) => {
                                    return (<tr key={curitem.prdct_id}>
                                        <td className="pt_title-box clearfix">
                                            <div className="product-thumbnail f-left">
                                                <div className="ed-front">
                                                    <img src={curitem.od_repr_img} alt="" />
                                                </div>
                                                <div className="ed-back">
                                                    <a href="#"><span>{getCateName(curitem.cate_name)}</span></a>
                                                </div>
                                            </div>
                                            <div className="product-title f-left">
                                                <p className="pt-title">
                                                    <a href="#">{curitem.prdct_nm}</a>
                                                </p>
                                                <div className="pt-option">
                                                    <p> <span>{curitem.opt_nm}</span></p>
                                                    <p>수량 : <span>{curitem.qty}</span>개</p>
                                                </div>
                                            </div>
                                        </td>
                                        {/* 상품금액 */}
                                        <td className="text_center">
                                            {getDscntPercent(curitem)}
                                            <p className="fontsize-14"><span className="font-mont">
                                                {Number(curitem.od_prdct_price.toFixed(1)).toLocaleString()}
                                            </span>원</p>
                                        </td>
                                        {/* 할인금액 */}
                                        <td className="text_center">
                                            {getDscntPriceNoDot(curitem)}
                                            {getAddDscntPrice(curitem)}
                                        </td>
                                        {/* 배송비 */}
                                        <td className="text_center">
                                            <div style={isCashOnDlvryShow(curitem)}>
                                                <p className="fontsize-14 gray-text">착불 배송비</p>
                                            </div>
                                            {getDetailDlvry(curitem)}
                                        </td>
                                        {/* 견적금액 */}
                                        <td className="text_center">
                                            <p className="pt-pay"><span className="font-mont">
                                                {Number(curitem.od_it_pay_price.toFixed(1)).toLocaleString()}</span>원</p>
                                        </td>
                                    </tr>
                                    )
                                })
                            }
                        </tbody>

                        <tfoot>
                            <tr className="total-pay_tr">
                                <td className="mint text_center">
                                    총 수량 <span className="font-mont">{esOrderInfo.data.orderinfo.od_prod_total_qty}</span>개
                                            </td>
                                <td className="mint text_center">
                                    <div className="total-pay minus-icon">
                                        <p className="pt-pay"><span className="font-mont">
                                            {Number(esOrderInfo.data.orderinfo.od_prod_sale_price.toFixed(1)).toLocaleString()}
                                        </span><span className="medium">원</span></p>
                                    </div>
                                </td>
                                <td className="mint text_center">
                                    <div className="total-pay plus-icon">
                                        <p className="pt-pay pink">
                                            <span className="font-mont">{getTotalDsctPrice(esOrderInfo.data.orderinfo)}</span>
                                            <span className="medium">원</span></p>
                                    </div>
                                </td>
                                <td className="mint text_center">
                                    <div className="total-pay equal-icon">
                                        <div style={{ display: esOrderInfo.data.orderinfo.od_dlvry_type === '025202' ? 'block' : 'none' }}>
                                            <p className="total-absolute fontsize-14 gray-text">착불 배송비</p>
                                        </div>
                                        {getDlvryPayInFooter(esOrderInfo.data.orderinfo)}
                                    </div>
                                </td>
                                <td className="mint text_center">
                                    <div className="total-pay">
                                        <p className="pt-pay"><span className="font-mont">
                                            {Number(esOrderInfo.data.orderinfo.od_pay_price.toFixed(1)).toLocaleString()}
                                        </span><span className="medium">원</span></p>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>

                </div>

                <p className="ess_text" style={{ display: isShowGuide ? 'block' : 'none' }}>* 주문 관련 문의는 고객센터로 연락주세요.</p>

            </div>
        </EsOrderDoneProdInfoBlock>
    );
};

export default EsOrderDoneProdInfo;
